import * as Sentry from "@sentry/react";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import ShutdownPage from './Customer/v2/components/ShutdownPage/ShutdownPage';
import * as serviceWorker from './serviceWorker';
import { environment } from './environment';

if (environment.SENTRY_ENABLED) {
  Sentry.init({
    dsn: environment.SENTRY_DSN ?? "https://a6fb173b140493125706188a754d2208@o1019049.ingest.us.sentry.io/4508812463374336",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/app\.rownd\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}
const el = document.getElementById('root');
if (el === null) throw new Error('Root container missing in index.html')
const root = ReactDOM.createRoot(el);

// Rownd has been sunset: the dashboard (and the Rownd sign-in hub) is replaced by a
// static notice pointing customers to SuperTokens.
root.render(<ShutdownPage />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
